import {
UPDATE_CLIENT_USER,
UPDATE_CLIENT_USER_SUCCESS,
UPDATE_CLIENT_USER_ERROR,
} from "./actionTypes"

const INIT_STATE = {
  client_user: [],
  error: null,
  loading: false,
}
const UpdateClientUser = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_CLIENT_USER:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case UPDATE_CLIENT_USER_SUCCESS:
      return {
        ...state,
        error: null,
        client_user: action.payload,
        loading: false,
      }

    case UPDATE_CLIENT_USER_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    default:
      return state
  }
}

export default UpdateClientUser
